module.exports = __webpack_public_path__ + "static/img/ph.89de517.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/ph.png
// module id = z/vM
// module chunks = 1